// =============================================================================
// POLITICAL GROUPS — issues, government job performance
// =============================================================================

export const POLITICAL_GROUPS = {


  // ===========================================================================
  // ISSUES — % mentioned each issue (multi-select categorical)
  // ===========================================================================

  vote_intention: {
    type: "categorical",
    label: "Voting Intention",
    fulltext: "If the next general election were held tomorrow…  Who would you vote for using your party-list vote?",
    weightCol: "turnout_1_n",
    keys: [
  "nat_pred_n",
  "lab_pred_n",
  "act_pred_n",
  "nzf_pred_n",
  "green_pred_n",
  "tpm_pred_n",
  "oth_pred_n"
    ],
    labels: {
      nat_pred_n:       "National",
      lab_pred_n:          "Labour",
      act_pred_n:            "ACT",
      nzf_pred_n:           "NZ First",
      green_pred_n:         "Green",
      tpm_pred_n:         "Te Pāti Māori",
      oth_pred_n:    "Other",
      
    },
colors: {
  nat_pred_n:   "#00529F",  // National blue
  lab_pred_n:   "#D82A20",  // Labour red
  act_pred_n:   "#FFD200",  // ACT yellow
  nzf_pred_n:   "#000000",  // NZ First black
  green_pred_n: "#098137",  // Green green
  tpm_pred_n:   "#B2001A",  // Te Pāti Māori dark red
  oth_pred_n:   "#808080",  // Other grey
},
  },


  // ===========================================================================
  // ISSUES — % mentioned each issue (multi-select categorical)
  // ===========================================================================

  issues: {
    type: "categorical",
    label: "Most important issues",
    fulltext: "What would you say are the three most important issues facing New Zealand today?",
    weightCol: "turnout_1_n",
    keys: [
      "inflation_issue_n",
      "health_issue_n",
      "econ_issue_n",
      "crime_issue_n",
      "housing_issue_n",
      "poverty_issue_n",
      "unemployment_issue_n",
      "climate_issue_n",
      "education_issue_issue_n",
      "transport_issue_n",
      "drugs_issue_n",
      "race_rel_issue_n",
      "tax_issue_n",
      "pollution_issue_n",
      "maori_issue_n",
      "immigration_issue_n",
      "defence_issue_n",
    ],
    labels: {
      inflation_issue_n:       "Inflation / cost of living",
      health_issue_n:          "Healthcare / hospitals",
      econ_issue_n:            "The economy",
      crime_issue_n:           "Crime / law and order",
      housing_issue_n:         "Housing",
      poverty_issue_n:         "Poverty / Inequality",
      unemployment_issue_n:    "Unemployment",
      climate_issue_n:         "Climate change",
      education_issue_issue_n: "Education",
      transport_issue_n:       "Transport and infrastructure",
      drugs_issue_n:           "Drug or alcohol abuse",
      race_rel_issue_n:        "Race relations / racism",
      tax_issue_n:             "Taxation",
      pollution_issue_n:       "Environmental pollution",
      maori_issue_n:           "Issues facing Māori",
      immigration_issue_n:     "Immigration",
      defence_issue_n:         "Defence and foreign affairs",
    },
    colors: {
      inflation_issue_n:       "#F2A832",
      health_issue_n:          "#4CAF50",
      econ_issue_n:            "#2196F3",
      crime_issue_n:           "#C62828",
      housing_issue_n:         "#00796B",
      poverty_issue_n:         "#795548",
      unemployment_issue_n:    "#7B1FA2",
      climate_issue_n:         "#388E3C",
      education_issue_issue_n: "#0288D1",
      transport_issue_n:       "#546E7A",
      drugs_issue_n:           "#4A148C",
      race_rel_issue_n:        "#E64A19",
      tax_issue_n:             "#F57F17",
      pollution_issue_n:       "#827717",
      maori_issue_n:           "#00695C",
      immigration_issue_n:     "#283593",
      defence_issue_n:         "#1A237E",
    },
  },

  // ===========================================================================
  // GOVERNMENT JOB PERFORMANCE — 3-point likert
  // ===========================================================================

  gov_performance: {
    type: "likert",
    label: "Government job performance",
    fulltext: "Thinking about the performance of the government in general, how good or bad a job do you think it has done over the last three years?",
    weightCol: "turnout_1_n",
    keys: [
      "gov_good_n",
      "gov_bad_n",
      "gov_dn_n",
    ],
    labels: {
      gov_good_n: "Good job",
      gov_bad_n:  "Bad job",
      gov_dn_n:   "Don't know",
    },
    colors: {
      gov_good_n: "#4CAF50",
      gov_bad_n:  "#F44336",
      gov_dn_n:   "#9E9E9E",
    },
    polarity: {
      pos: ["gov_good_n"],
      neg: ["gov_bad_n"],
      dk:  "gov_dn_n",
    },
  },

};
